import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "AudioViewer";
var classes = {
    coverImage: "".concat(PREFIX, "-details")
};
var StyledAudioViewer = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "coverImageMaxHeight" && prop !== "coverImageCover"; }
})(function (_a) {
    var _b;
    var theme = _a.theme, _c = _a.coverImageMaxHeight, coverImageMaxHeight = _c === void 0 ? 12 : _c, _d = _a.coverImageCover, coverImageCover = _d === void 0 ? true : _d;
    return (_b = {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            // Transparent background, you'll need to set it yourself if you want one
            // That way it make it easier to "containerize" the component yourself
            backgroundColor: "transparent",
            width: "100%"
        },
        // On smaller screen, display the image cover before the player, not on the same line
        _b[theme.breakpoints.down("sm")] = {
            flexDirection: "column"
        },
        _b["& .MuiButtonBase-root"] = {
            minWidth: "100%"
        },
        _b["& .material-icons"] = {
            fontSize: "1em"
        },
        /**
         * Theses CSS classes are exposed by the lib
         * To override the UI, the doc mention the possibility to override SASS variables
         * (https://github.com/lhz516/react-h5-audio-player)
         * But this way seems to be the cleaner / easier in our context
         */
        _b["& .rhap_container"] = {
            backgroundColor: "transparent",
            boxShadow: "none"
        },
        _b["& .rhap_volume-button"] = {
            position: "relative",
            top: "2px"
        },
        _b["& .rhap_time, & .rhap_repeat-button, & .rhap_main-controls-button, & .rhap_volume-button, & button[class*='MuiIconButton']"] = {
            color: theme.palette.primary.main,
            // to not crop material ui custom icon buttons
            height: "auto",
            width: "auto"
        },
        _b["& .rhap_volume-bar, & .rhap_volume-indicator, & .rhap_progress-indicator, & .rhap_progress-filled"] = {
            backgroundColor: theme.palette.primary.main
        },
        _b["& .rhap_progress-bar-show-download"] = {
            // to handle transparency we append a number to hexa code returned by the theme
            backgroundColor: "".concat(theme.palette.primary.main, "40")
        },
        _b["& .".concat(classes.coverImage)] = {
            backgroundColor: "transparent",
            objectFit: coverImageCover ? "cover" : "contain",
            maxHeight: "".concat(coverImageMaxHeight, "rem"),
            height: "100%",
            width: "35vw"
        },
        _b);
});

export { classes, StyledAudioViewer as default };
//# sourceMappingURL=index.styles.js.map
